import { render, staticRenderFns } from "./other.vue?vue&type=template&id=123219b3&scoped=true"
import script from "./other.vue?vue&type=script&lang=js"
export * from "./other.vue?vue&type=script&lang=js"
import style0 from "./other.vue?vue&type=style&index=0&id=123219b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123219b3",
  null
  
)

export default component.exports